import { AUDIO_FILE, IMAGE_FILE, VIDEO_FILE, PDF_FILE } from '@shoflo/polymer';

export const getFileExtension = fileName => {
  const extPattern = /\.[0-9a-z]+$/i;

  let matches = extPattern.exec(fileName);

  if (!Array.isArray(matches)) return '';

  const [extMatch] = matches;

  return extMatch.toLowerCase();
};

export const FileExtensionMap = {
  '.jpg': IMAGE_FILE,
  '.jpeg': IMAGE_FILE,
  '.gif': IMAGE_FILE,
  '.png': IMAGE_FILE,
  '.mp4': VIDEO_FILE,
  '.mp3': AUDIO_FILE,
  '.wav': AUDIO_FILE,
  '.pdf': PDF_FILE,
  '.m4v': VIDEO_FILE,
  '.avi': VIDEO_FILE,
  '.mov': VIDEO_FILE,
  '.wmv': VIDEO_FILE,
  '.webm': VIDEO_FILE,
  '.mpeg': VIDEO_FILE,
  '.mpg': VIDEO_FILE,
  '.mpg2': VIDEO_FILE,
  '.mpe': VIDEO_FILE,
  '.mpv': VIDEO_FILE,
  '.qt': VIDEO_FILE
};

/**
 * @param {Array} templates the data array to filter
 * @param {String} fileType the data array to filter
 * @return {*}
 */
export const filterByValidFileExtension = (templates, fileType = null) => {
  return templates.filter(template => {
    const extension = getFileExtension(template.name || template.key);
    if (fileType) {
      return FileExtensionMap[extension] === fileType;
    }
    return !!FileExtensionMap[extension];
  });
};

const ImageDimensionLimits = {
  height: 1080,
  width: 1920
};

export const validateImageDimensions = file => {
  return new Promise(resolve => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = function (e) {
      const image = new Image();

      image.src = e.target.result;
      image.onload = function () {
        const height = this.height;
        const width = this.width;

        const isValid =
          height <= ImageDimensionLimits.height &&
          width <= ImageDimensionLimits.width;

        resolve(isValid);
      };
    };
  });
};
